import { useEffect, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/** Jumlah produk baru yang menunggu konfirmasi (untuk lencana menu).
 *  Ringan: satu GET kecil tiap 2 menit, dan saat halaman konfirmasi berubah.
 *  Gagal diam-diam (sinyal lemah tidak boleh mengganggu layout). */
export default function useProductConfirmCount(enabled = true) {
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!enabled) return undefined;
    let alive = true;
    const load = async () => {
      try {
        const token = localStorage.getItem('token');
        if (!token) return;
        const r = await axios.get(`${API}/product-confirmations/count`, {
          headers: { Authorization: `Bearer ${token}` },
          timeout: 8000,
        });
        if (alive) setCount(r.data?.count || 0);
      } catch (e) {
        /* abaikan */
      }
    };
    load();
    const t = setInterval(load, 120000);
    window.addEventListener('product-confirmations-changed', load);
    return () => {
      alive = false;
      clearInterval(t);
      window.removeEventListener('product-confirmations-changed', load);
    };
  }, [enabled]);
  return count;
}
